import BehandelduurDvt from "../../../../src/client/katnh/widgets/BehandelduurDvt.js";
import * as React from 'react';
export default {
  BehandelduurDvt,
  React
};